// extracted by mini-css-extract-plugin
module.exports = {"headerIcon":"_93ea05c","betSlipOpen":"_11d3065","title":"_8bd243f","content":"_864955f","count":"_9b8bc20"};